const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  userInfo: state => state.user.userInfo,
  roles: state => state.user.roles,
  history: state => state.history.history,
  permission: state => state.promission.routes,
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js